import { React, useContext, useState } from "react";
import expand from "../../assets/icons/expandDedault.png";
import { AppContext } from "../../Context/Context";
import useMinimizedModalFeature from "../../hooks/useMinimizedModalFeature";
import { useDispatch, useSelector } from "react-redux";
import { setFollowingLgvList } from "../../store/plantSlice";

const FollowingLgvObjects = () => {
  const { setIsMarkerPopupOpen, setSelectedMarkerData, setSelectedMarkerType } =
    useContext(AppContext);

  const { followingLgvList } = useSelector((state) => state.plant);

  const dispatch = useDispatch();

  const { feature } = useMinimizedModalFeature();

  const [isLgvFollowingListOpened, setIsLgvFollowingListOpened] =
    useState(false);

  const maximizeModal = (item, type) => {
    setSelectedMarkerData(item);
    setSelectedMarkerType(type);
    setIsMarkerPopupOpen(true);
  };

  const closeAllMinimizedModals = (type) => {
    if (type === "followingLgv") {
      dispatch(setFollowingLgvList({ feature, list: [] }));
      minimizeFollowingLGVsHandler();
    }
  };
  //Following LGVs
  const minimizeFollowingLGVsHandler = () => {
    setIsLgvFollowingListOpened(!isLgvFollowingListOpened);
  };

  const unFollowParticularLgv = (item) => {
    let localFollowingLgvList = [...followingLgvList[feature]];

    let indexOfItemToDelete = localFollowingLgvList.indexOf(item);
    localFollowingLgvList.splice(indexOfItemToDelete, 1);

    dispatch(setFollowingLgvList({ feature, list: localFollowingLgvList }));
  };

  if (followingLgvList[feature].length === 0) {
    return <></>;
  }
  return (
    <div className="followed-objects-wrapper">
      <div className="followed-objects-container">
        <div className="followed-objects-row-wrapper">
          <div className="minimized-objects-expanded-view-body">
            {isLgvFollowingListOpened && (
              <div className="minimized-objects-expanded-view minimized-objects-expanded-view-production-line-width minimized-objects-follow-lgv-extra-bottom-space">
                <div className="minimized-objects-expanded-view-header">
                  <span className="minimized-objects-expanded-view-header-title">
                    LGVs Following
                  </span>
                  <span
                    onClick={() => closeAllMinimizedModals("followingLgv")}
                    className="minimized-objects-expanded-view-header-close"
                  >
                    UnFollow All
                  </span>
                </div>
                <div className="minimized-objects-expanded-view-body">
                  {followingLgvList[feature].map((item, index) => (
                    <div
                      key={index}
                      className="minimized-objects-expanded-view-body-item"
                      onClick={() => maximizeModal(item, "lgv")}
                    >
                      <span>LGV {item.vehicleNumber}</span>
                      <div className="object-items-actions-buttons-container">
                        <p
                          onClick={(e) => {
                            e.stopPropagation(); // Prevents triggering maximize
                            unFollowParticularLgv(item);
                          }}
                          className="following-lgv-card-container-toggler"
                        >
                          UnFollow
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {followingLgvList[feature].length > 0 && (
              <div
                onClick={minimizeFollowingLGVsHandler}
                className="minimize-card-container"
              >
                <p className="minimize-card-container-title">LGVs Following</p>
                <div className="minimize-card-container-count-container extra-space-badge">
                  <p className="minimize-card-container-count">
                    {followingLgvList[feature].length} / 5
                  </p>
                </div>
                <p className="minimize-card-container-toggler">
                  <img
                    className={`rotate-arrow-on-click ${
                      isLgvFollowingListOpened
                        ? "rotate-down-arrow-on-click"
                        : "rotate-up-arrow-on-click"
                    }`}
                    src={expand}
                    alt="top_arrow_icon"
                  />
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowingLgvObjects;
